import { render, staticRenderFns } from "./tag-input.vue?vue&type=template&id=b0c930e4&scoped=true&"
import script from "./tag-input.vue?vue&type=script&lang=js&"
export * from "./tag-input.vue?vue&type=script&lang=js&"
import style0 from "./tag-input.vue?vue&type=style&index=0&id=b0c930e4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c930e4",
  null
  
)

export default component.exports